import { CustomCalendarType, SimpleActivity } from "@ac-expo/api-types";
import { FileType } from "@prisma/client";
import { noop } from "lodash";
import { EventSchedulesTimes, PlanningEvent } from "../../planning";
import Planning from "../../planning/Planning";

type ProgramPanelProps = {
  activities: SimpleActivity[];
  eventSchedules?: EventSchedulesTimes[];
  isRegisterEnabled?: boolean;
  openActivityList?: (events: PlanningEvent[]) => void;
  customCalendar?: CustomCalendarType;
  getFileUrl?: (key?: string, type?: FileType, width?: number) => string;
};

const ProgramPanel = ({
  isRegisterEnabled = true,
  activities,
  eventSchedules,
  openActivityList,
  customCalendar,
  getFileUrl,
}: ProgramPanelProps) => {
  const onOpenActivityList = openActivityList ?? noop;

  return (
    <Planning
      activities={activities}
      eventSchedules={eventSchedules}
      className="h-fit"
      openActivitiesDetails={onOpenActivityList}
      isRegisterEnabled={isRegisterEnabled}
      customCalendar={customCalendar}
      getFileUrl={getFileUrl}
    />
  );
};

export default ProgramPanel;
